import { Controller, useFormContext } from 'react-hook-form'
import { FiscalNoteFormData } from '../../schema'
import { MenuItem, TextField } from '@mui/material'
import { useEffect } from 'react'
import { CNAECompany } from '@/types/company'

type CNAEProps = {
  cnaes?: CNAECompany[]
}

export function CNAE({ cnaes = [] }: CNAEProps) {
  const { control, setValue } = useFormContext<FiscalNoteFormData>()

  useEffect(() => {
    const primaryCnae = cnaes.find((cnae) => cnae.is_primary)

    if (primaryCnae) {
      setValue('cnae_id', primaryCnae.cnae_id.toString())
    }
  }, [cnaes])

  return (
    <Controller
      control={control}
      name="cnae_id"
      render={({ field, fieldState: { error } }) => (
        <TextField
          select
          label="CNAE"
          error={!!error}
          helperText={error?.message}
          slotProps={{
            select: {
              MenuProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    whiteSpace: 'normal',
                  },
                },
              },
            },
          }}
          data-testid="cnae-id"
          {...field}
        >
          {cnaes.map(({ cnae }: CNAECompany) => (
            <MenuItem key={cnae?.id} value={cnae?.id.toString()}>
              {cnae?.code} - {cnae?.description}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}
